module.exports = __webpack_public_path__ + "606a19f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/media_pcm.png
// module id = 1690
// module chunks = 0